import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg';
import imgBrillante from '../assets/corte/tressor_corte-brillante.webp';
import imgPrincesa from '../assets/corte/tressor_corte-princess.webp';
import imgOvalado from '../assets/corte/tressor_corte-ovalado.webp';
import imgCushion from '../assets/corte/tressor_corte-cushion.webp';
import iconBrillante from '../assets/tressor-sketches_icono_redondo.svg';
import iconPrincesa from '../assets/tressor-sketches_icono_princesa.svg';
import iconOvalado from '../assets/tressor-sketches_icono_ovalado.svg';
import iconCushion from '../assets/Tressoriconocushion.png';
import portadaCorte from '../assets/portadas/Portada-03-Corte.webp'


const Step2 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.cutStyle || null);

  const options = [
    {
      id: 1,
      icon: iconBrillante,
      text: "Brillante",
      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      title: "Redondo / brillante",
      description: "También conocido como corte redondo, el corte tradicional.",
      image: imgBrillante,
    },
    {
      id: 2,
      icon: iconPrincesa,
      text: "Princesa",
      value1: -1720,
      value2: -3225,
      value3: -4300,
      value4: -5375,
      title: "Princesa",
      description: "Diamante con corte cuadrado.",
      image: imgPrincesa,
    },
    {
      id: 3,
      icon: iconOvalado,
      text: "Ovalado",
      value1: -1720,
      value2: -3225,
      value3: -4300,
      value4: -5375,
      title: "Ovalado",
      description: "Diamante con corte oval",
      image: imgOvalado,
    },
    {
      id: 4,
      icon: iconCushion,
      text: "Cushion",
      value1: -1720,
      value2: -3225,
      value3: -4300,
      value4: -5375,
      title: "Cushion",
      description: "Diamante corte “cojín”",
      image: imgCushion,
    }
  ];

  const handleOptionSelect = (option) => {
    const selectedCaratId = formData?.carats?.selectedId;
    const valueKey = `value${selectedCaratId}`;
    const finalValue = selectedCaratId ? option[valueKey] : option.value1;

    setSelectedOption(option);
    handleInputChange('cutStyle', {
      ...option,
      value: finalValue
    });
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Selecciona el Corte del Diamante</h2>
            <p className='text-size-medium text-color-grey'>Eligiendo el que mejor refleje su estilo y personalidad:
            </p>
            <div className='container-radio-options'>
            <div className='wrapp-radio-options'>
              <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="cutStyle"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon-corte" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
              </div>

            </div>
            </div>
           
            
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
              className="button" 
              onClick={nextStep}
              disabled={!selectedOption}
            >
              Siguiente
              <img src={iconArrowRight} alt="arrow right" />
            </button>
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={portadaCorte} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Corte</p>
                <p className='text-size-large text-color-white text-align-left'>Por favor selecciona un corte</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step2;
























